import {Component, ElementRef, forwardRef, Host, Injector, Input, OnInit, Optional, SkipSelf} from '@angular/core';
import {ControlContainer, ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ValueAccessorAbstract} from '@wba-ui-module/components/formfields/commons/value-accessor.abstract';
import {EventUtils} from '@wba/utils/event.utils';
import {ACTIONS_TYPES, EVENT_KATEGORIE, PiwikService} from '@wba/commons/modules/piwik';

@Component({
    selector: 'wba-input-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckboxComponent),
            multi: true
        }],
    standalone: false
})
export class CheckboxComponent extends ValueAccessorAbstract implements ControlValueAccessor, OnInit {

  @Input() _id: string;
  @Input() name: string;
  @Input() errorLabel: string;
  @Input() ariaLabel: string;
  @Input() title: string;
  @Input() required: string;
  @Input() dataAnalyticsName = '';
  @Input() hinweis: { target: string, modal: string };
  @Input() disabled: boolean;

  public control: FormControl;
  private isEventSent = false;

  constructor(@Optional() @Host() @SkipSelf() private readonly controlContainer: ControlContainer,
              private readonly eventUtils: EventUtils,
              private readonly piwikService: PiwikService,
              private readonly elementRef: ElementRef,
              protected injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    super.ngOnInit();
    if (this.controlContainer) {
      if (this.formControlName) {
        this.control = this.controlContainer.control.get(this.formControlName) as FormControl;
      }
    }
  }

  // Set touched on blur
  onBlur() {
    this.onTouchedCallback();
    this.eventUtils.focusOut$.next(this.elementRef);
  }

  get hasErrorAndTrackPiwik() {
    const hasControlErrors = this.control?.touched && this.control?.errors;
    if ( hasControlErrors && this.dataAnalyticsName && !this.isEventSent) {
      this.isEventSent = true;
      this.piwikService.trackEventAction(EVENT_KATEGORIE.FEHLER, ACTIONS_TYPES.FORM, this.dataAnalyticsName);
    }
    return hasControlErrors;
  }
}
